<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.systemClients)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                                <h4 class="order-title" style="display: flex;align-items: center;">
                                   <b>{{translate(locale.clientInfo)}}</b>
                                    <router-link :to="'/system_clients/edit/' + client.hash">
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">{{translate(locale.edit)}}</md-tooltip>
                                        </md-button>
                                    </router-link>
                                    <router-link :to="'/system_clients/new_channel/' + client.hash">
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>add_alert</md-icon>
                                            <md-tooltip md-direction="top">{{translate(locale.newChannel)}}</md-tooltip>
                                        </md-button>
                                    </router-link>
                                    <md-button class="md-just-icon md-simple md-primary" @click="revoke(client.hash)">
                                        <md-icon>restart_alt</md-icon>
                                        <md-tooltip md-direction="top">{{translate(locale.revokeKey)}}</md-tooltip>
                                    </md-button>
                                </h4>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-60">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">{{translate(locale.code)}}</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(client.id).length > 0"><b>{{client.hash}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.clientName)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(client.name).length > 0"><b>{{client.name}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.apiKey)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(client.phone).length > 0"><b>{{client.api_key}}</b></span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.status)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span class="late" v-if="client.status == 0">{{translate(locale.disabled)}}</span>
									        <span class="green" v-if="client.status == 1">{{translate(locale.active)}}</span>
                                        </md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-40">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">{{translate(locale.createdDate)}}</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(client.last_login).length > 0"><b>{{translate(config.datelify(client.created_date))}}</b> ({{translate(config.getAge(client.created_date))}})</span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.updatedDate)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="String(client.last_login).length > 0"><b>{{translate(config.datelify(client.updated_date))}}</b> ({{translate(config.getAge(client.updated_date))}})</span>
                                            <span v-else>N/A</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userName)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{client.user_name}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>{{translate(locale.userRole)}}</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <b><span v-if="client.user_role == 'super-admin'">{{translate(locale.roleSuperAdmin)}}</span>
                                                <span v-if="client.user_role == 'user'">{{translate(locale.roleUser)}}</span></b>
                                        </md-table-cell>
                                    </md-table-row>
                                    
                                </md-table>
                            </div>

                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                                <h4 class="order-title" style="display: flex;align-items: center;">
                                   <b>{{translate(locale.channelList)}}</b>
                                </h4>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
                                <md-table>
                                    <md-table-row>
                                        <md-table-head>{{translate(locale.channelName)}}</md-table-head>
                                        <md-table-head>{{translate(locale.channelCode)}}</md-table-head>
                                        <md-table-head>{{translate(locale.clientTelegramBotToken)}}</md-table-head>
                                        <md-table-head>{{translate(locale.clientTelegramChatId)}}</md-table-head>
                                        <md-table-head>{{translate(locale.notification)}}</md-table-head>
                                        <md-table-head>{{translate(locale.action)}}</md-table-head>
                                    </md-table-row>
                                    <md-table-row v-for="(channel, index) in channelList">
                                        <md-table-cell>{{channel.name}}</md-table-cell>
                                        <md-table-cell>{{channel.slug}}</md-table-cell>
                                        <md-table-cell>{{channel.telegram_bot_token}}</md-table-cell>
                                        <md-table-cell>{{channel.telegram_chat_id}}</md-table-cell>
                                        <md-table-cell>
                                            <span v-if="channel.notification_normal_log == 'on'"><span style="color:green; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationNormalLog)}} (1)<br></span>
                                            <span v-if="channel.notification_warning_log == 'on'"><span style="color:orange; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationWarningLog)}} (2)<br></span>
                                            <span v-if="channel.notification_critical_log == 'on'"><span style="color:red; font-size: 20px;">&#10687; </span>{{translate(locale.sendNotificationCriticalLog)}} (3)</span>
                                        </md-table-cell>
                                        <md-table-cell>
                                            <router-link :to="'/system_clients/edit_channel/' + channel.hash">
                                                    <md-icon class="md-primary">edit</md-icon>
                                                    <md-tooltip md-direction="top">{{translate(locale.edit)}}</md-tooltip>
                                            </router-link>
                                        </md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>

                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                                <h4 class="order-title" style="display: flex;align-items: center;">
                                   <b>{{translate(locale.integration)}}</b>
                                </h4>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 100%;">{{config.endpoint}}<b>api_key</b>={{client.api_key}}&<b>channel</b>={channelCode}&<b>level</b>={1,2,3}&<b>log</b>={logString}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
						</div>
					</div>
                    <md-dialog-confirm :md-active.sync="revokeDialogActive" :md-title="translate('Are you sure wanting to revoke this API Key ?||តើអ្នកពិតជាចង់បង្កើត API Key ថ្មីមែនទេ ?')" :md-confirm-text="translate('Confirm||យល់ព្រម')" :md-cancel-text="translate('Cancel||បោះបង់')"
                    @md-cancel="onCancel" @md-confirm="revoke()" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	export default {
		components: {  },
		created() {
			this.getClient();
		},
		data() {
			return {
				loaded: false,
				client: {
					hash: "",
					name: "",
					api_key: "",
                    user_name: "",
                    user_role: "",
                    created_date: "",
                    updated_date: "",
                    status: ""
				},
                channelList: [],
				revokeDialogActive: false
			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash).then(data => {
					this.client = data.body.data.client;
                    this.channelList = data.body.data.channel;
                    let notification = data.body.data.notification;

                    for(let i = 0; i<this.channelList.length; i++) {
                        for(let j = 0; j< notification.length; j++) {
                            if(notification[j].hash == this.channelList[i].hash) {
                                if(notification[j].level_id == 1) this.channelList[i].notification_normal_log = "on";
                                if(notification[j].level_id == 2) this.channelList[i].notification_warning_log = "on";
                                if(notification[j].level_id == 3) this.channelList[i].notification_critical_log = "on";
                            }   
                        }
                    }

					this.loaded = true;
				})
			},
			revoke() {
                if(!this.revokeDialogActive) {
                    this.revokeDialogActive = true;
                    return;
                }
				this.$http.post(this.config.api + "/admin/client/revoke", {
                    hash: this.$route.params.hash
                }).then(data => {
                    if (data.body.status == 'success') {
                        this.getClient();
                    }
                })
			},
			onCancel() {
				this.revokeDialogActive = false;
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Detail.vue